import { request } from '@/plugins/http';

/**
 * dbc列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDbcList = params => request('/dbcflie/getDbcFileList', params);

/**
 * 新增
 * @param params
 * @returns {AxiosPromise}
 */
const addDataDbcFile = params => request('/dbcflie/addDataDbcFile', params);

/**
 * 修改
 * @param params
 * @returns {AxiosPromise}
 */
const updateDataDbcFile = params => request('/dbcflie/updateDataDbcFile', params);

/**
 * 删除
 * @param params
 * @returns {AxiosPromise}
 */
const delDbcFiles = params => request('/dbcflie/delDbcFiles', params);

/**
 * 上传DBC
 * @param params
 * @returns {AxiosPromise}
 */
const uploadDbcFile = params => request('/dbcflie/uploadDbcFile', params);

/**
 * 下载DBC
 * @param params
 * @returns {AxiosPromise}
 */
const downloadDbcFile = params => request('/dbcflie/downloadDbcFile', params);

export {
    getDbcList,addDataDbcFile,uploadDbcFile,updateDataDbcFile,delDbcFiles,downloadDbcFile
};
